export default function SectionTitle({ title, darkMode }) {
    return(
        
        <div className={`section-title-container ${ ! darkMode ? 'light': ''}`}>
            <p>{title}</p>
        </div>
    )
}